<template>
  <div class="performance-add-edit-dialog">
    <el-dialog
      :title="isEdit ? '编辑评估指标组' : '添加评估指标组'"
      :visible.sync="dialogStatus"
      destroy-on-close
      :close-on-click-modal="false"
      width="580px"
      :before-close="dialogBeforeClose"
    >
      <el-form
        :model="formData"
        :rules="formRules"
        ref="performanceDom"
        label-width="120px"
      >
        <el-form-item label="评估指标组名称" prop="groupName">
          <el-input
            class="yioks-form-item"
            v-model.trim="formData.groupName"
            placeholder="请填写评估指标组名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="评估指标组类型" prop="jixiaoType">
          <el-select
            class="yioks-form-item"
            v-model="formData.jixiaoType"
            placeholder="请选择指标组类型"
          >
            <el-option
              v-for="item in performanceGroupTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="备注">
          <el-input
            class="yioks-form-item"
            v-model.trim="formData.remark"
            placeholder="请填写备注信息"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="footer-btn-group">
        <el-button type="primary" @click="handleClose(true)">确 定</el-button>
        <el-button type="danger" @click="handleClose(false)">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { performanceGroupTypeList } from "@/assets/js/yioksSelect";
import { postPerformanceGroup, putPerformanceGroup } from "@/api/performance";
import { requiredItem } from "@/assets/js/formRules";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
      requeired: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
      required: false,
    },

    defaultInfo: {
      type: Object,
      default: {
        groupName: "",
        // jixiaoType: "",
        remark: "",
      },
    },
  },

  data() {
    return {
      formData: {
        groupName: "",
        // jixiaoType: "",
        remark: "",
      },
      formRules: {
        groupName: [requiredItem("指标组名称")],
        // jixiaoType: [requiredItem("指标组类型")],
      },
      performanceGroupTypeList,
    };
  },

  computed: {
    dialogStatus: {
      get() {
        return this.isOpen;
      },
      set(val) {
        this.$emit("closeGroupDialog", val, false);
      },
    },
  },

  mounted() {
    this.setDefaultData();
  },

  methods: {
    setDefaultData() {
      if (!this.isEdit) return;
      // const { uuid, remark, jixiaoType, groupName } = this.defaultInfo;
      this.formData = Object.assign({}, this.formData, this.defaultInfo);
    },

    dialogBeforeClose() {
      this.formData = {
        groupName: "",
        // jixiaoType: "",
        remark: "",
      };
      this.$emit("closeGroupDialog", false, false);
    },
    handleClose(status) {
      if (status) {
        // 确认添加
        this.$refs.performanceDom.validate((valid) => {
          if (valid) {
            const postData = this.formData;
            let requestName = this.isEdit
              ? putPerformanceGroup
              : postPerformanceGroup;
            requestName(postData)
              .then((res) => {
                if (res.code) {
                  this.$message.error(res.msg);
                  return;
                }
                this.$emit("closeGroupDialog", false, status);
              })
              .catch((err) => {
                console.error("err", err);
                this.$message.error("操作失败，请稍后重试！");
              });
          } else {
            console.warn("校验不通过");
          }
        });
      } else {
        // 取消添加
        this.$emit("closeGroupDialog", false, status);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.yioks-form-item
  width 340px
.footer-btn-group
  width 60%
  margin 0 auto
  display flex
  justify-content space-around
</style>